import Vue from 'vue'
//全局配置请求信息
// Vue.prototype.baseURL = 'https://courseapi.tongshike.cn';
// Vue.prototype.baseURL1 = 'https://apps.tongshike.cn';
Vue.prototype.baseURL = 'https://www.idufep.com/ios/'
Vue.prototype.baseURL1 = 'https://www.idufep.com/ios/'
Vue.prototype.rescourceURL = 'http://tskcloud.qiniudn.com/'
Vue.prototype.pathURL = 'http://d.tongshike.cn'
// Vue.prototype.pathURL="http://d.dongc.cn";
// Vue.prototype.SCREEN_DOMAIN = 'http://swt.tongshike.cn/#/';
if (location.href.indexOf('.ulearning.cn') != -1) {
  Vue.prototype.baseURL = 'https://courseapi.ulearning.cn'
  Vue.prototype.baseURL1 = 'https://apps.ulearning.cn'
  Vue.prototype.rescourceURL = 'https://leicloud.ulearning.cn/'
  Vue.prototype.pathURL = 'http://d.ulearning.cn'
  // Vue.prototype.pathURL="http://d.idufep.com";
}
// if(common.getCookie('Authorization')){
//     axios.defaults.headers.common['Authorization'] = common.getCookie('Authorization');
// }



// WEBPACK FOOTER //
// ./src/common/js/plugIn.js